import { render, staticRenderFns } from "./inspectgroup.vue?vue&type=template&id=025dd5d5&"
import script from "./inspectgroup.vue?vue&type=script&lang=js&"
export * from "./inspectgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports